/* eslint-disable no-unused-vars */

import React from "react";
import { Group, Avatar, Text, Accordion, Container, Grid } from "@mantine/core";
import data from "./faq-data.json";
import AnimatedText from "react-animated-text-content";
import "../../Pages/Dashboard.css";
interface AccordionLabelProps {
  label: string;
}
function AccordionLabel({ label }: AccordionLabelProps) {
  return (
    <Group style={{ marginTop: 10 }}>
      <Text size="md">{label}</Text>
    </Group>
  );
}
export const Faq = () => {
  const items = data.map((item) => (
    <Accordion.Item label={<AccordionLabel {...item} />} key={item.label}>
      <Text size="md">{item.content}</Text>
    </Accordion.Item>
  ));

  return (
    <Container style={{ width: "100%" }}>
      <Text style={{ fontSize: "25px" }}>Got any Questions?</Text>
      <Text style={{ fontSize: "25px" }}>Check if we got them answered.</Text>
      <Accordion
        transitionDuration={500}
        initialItem={-1}
        iconPosition="right"
        style={{ marginTop: 15 }}
      >
        {items}
      </Accordion>
    </Container>
  );
};
